<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <b-card class="w-100">
          <b-tabs>
            <b-tab id="tab-left-1" title="รายละเอียดเรื่องแจ้งเบาะแส">
              <ClueDetail :clueData="clueData" />
            </b-tab>
            <TabAttachFiles
              @handle-upload="onAttachFileUploaded"
              @handle-delete="onAttachFileDelete"
              :attachFiles="clueData.attachFiles"
              :attachFileDate="clueData.attachFileDates"
              :IsEdit_TabAttachFiles="false"
            />
          </b-tabs>
        </b-card>
      </b-row>
    </b-col>
    <b-col cols="4">
      <b-card>
        <ClueTrackingVue
          :hightlightLasted="true"
          @handle-update-comment="onUpdateCommentClicked"
        />
        <div class="d-flex justify-content-end">
          <b-button
            variant="success"
            class="ml-1"
            @click="onClueTrackingStepBackClicked"
            >ลบสถานะหน่วยงานล่าสุด</b-button
          >
          <b-button
            variant="primary"
            class="ml-1"
            @click="onClueTrackingDetailStepBackClicked"
            >ลบสถานะล่าสุด</b-button
          >
        </div>

        <b-tabs class="mt-2">
          <b-tab id="tab-send-1" title="ส่งต่อหน่วยงานภายใน">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form">
                <ValidationProvider
                  rules="required"
                  name="หน่วยงาน"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 "
                    label="หน่วยงาน"
                    label-for="officer"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="internalDep"
                      :options="internalDeps"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="เจ้าหน้าที่ผู้ดำเนินการ"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 mt-1"
                    label="เจ้าหน้าที่ผู้ดำเนินการ"
                    label-for="officer"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="officer"
                      :options="officers"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="ความเห็นเจ้าหน้าที่"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="ความเห็นเจ้าหน้าที่"
                    label-for="offficerComment"
                    class="ml-1 mt-1"
                  >
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                      v-model="comment"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="primary"
                class="ml-1"
                @click="onTrackingSendInternalDep"
                >ส่งต่อหน่วยงานภายใน</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-2" title="ส่งต่อจังหวัด">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form2">
                <ValidationProvider
                  rules="required"
                  name="จังหวัด"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 "
                    label="จังหวัด"
                    label-for="province"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="province"
                      :options="provinces"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="เจ้าหน้าที่ผู้ดำเนินการ"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 mt-1"
                    label="เจ้าหน้าที่ผู้ดำเนินการ"
                    label-for="officer"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="officer"
                      :options="officers"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="ความเห็นเจ้าหน้าที่"
                  v-slot="{ errors }"
                >
                  <div class="w-100">
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                      v-model="comment"
                      class="mt-1 pl-1"
                    />
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="info"
                class="ml-1"
                @click="onTrackingSendProvince"
                >ส่งต่อจังหวัด</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-3" title="แก้ไขช่องทาง">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form3">
                <ValidationProvider
                  rules="required"
                  name="ช่องทาง"
                  v-slot="{ errors }"
                >
                  <div class="w-100">
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="channel"
                      :options="channels"
                      @input="selectOnInput"
                      class="mt-1 pl-1"
                    />
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="outline-primary"
                class="ml-1"
                @click="onClueTrackingChangeChannel"
                >แก้ไขช่องทาง</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-4" title="ลบเรื่องแจ้งเบาะแส">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form4">
                <ValidationProvider
                  rules="required"
                  name="รหัสยืนยัน"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="รหัสยืนยัน"
                    label-for="deletePin"
                    class="ml-1 mt-1"
                  >
                    <span class="text-danger">กรอกคำว่า ลบข้อมูล</span>
                    <b-form-input
                      id="deletePin"
                      placeholder="กรอกคำว่า ลบข้อมูล"
                      v-model="deletePin"
                      autocomplete="off"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button variant="danger" class="ml-1" @click="onDelete"
                >ลบเรื่องร้องทุกข์</b-button
              >
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
    <UpdateCommentModal ref="modal-update-comment" />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import ClueDetail from "../components/ClueDetail";

import RightTab from "../../components/RightTabAction.vue";

import TabAttachFiles from "../components/TabAttachFiles.vue";

import * as clueStore from "@/store/api/clue/index.js";
import * as clueManageStore from "@/store/api/clueManage/index.js";
import * as userStore from "@/store/api/user/index.js";

import * as userData from "@/auth/localStorageUtils.js";
import ClueTrackingVue from "../../components/TrackingComplaint/ClueTracking.vue";
import UpdateCommentModal from "../components/UpdateCommentModal.vue";
import * as storeMaster from "@/store/api/master/index.js";

import VueSelect from "vue-select";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  name: "ClueAdminManage",
  components: {
    VueSelect,
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BFormInput,
    BFormGroup,
    RightTab,
    TabAttachFiles,
    ClueDetail,
    ClueTrackingVue,
    UpdateCommentModal,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      clueData: {
        attachFiles: [],
        attachFileDates: [],
      },
      internalDep: null,
      internalDeps: [],
      comment: "",
      province: null,
      provinces: [],
      deletePin: "",
      officers: [],
      officer: null,
      channels: [],
      channel: null,
    };
  },
  mounted() {
    this.getClueData();
    this.getInternalDeps();
    this.getProvinces();
    this.getOfficer();
    this.getChannels();
  },
  methods: {
    getClueData() {
      const _this = this;
      clueStore
        .getById(this.$route.query.id)
        .then((response) => {
          _this.clueData = response.data.data;
          console.log("getClueData", response.data.data);
          // console.log("getClueData", _this.clueData.attachFiles);
          // console.log("getClueData", _this.clueData.attachFileDates);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onAttachFileUploaded(file) {
      const _this = this;
      console.log("onAttachFileUploaded", file);
      _this.clueData.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      console.log("onAttachFileDelete", id, file);
      const file = this.clueData.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      console.log("attachFiles", filteredAry);

      var filteredAry = this.clueData.attachFiles.filter(
        (o) => o.attachId != id
      );

      this.clueData.attachFiles = filteredAry;
    },
    onTrackingSendInternalDep() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked("ClueTrackingSendToDep");
      });
    },
    onTrackingSendProvince() {
      this.$refs.form2.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked("ClueTrackingSendToProvince");
      });
    },
    onClueTrackingStepBackClicked() {
      this.onSubmitBtnClicked("ClueTrackingStepBack");
    },
    onClueTrackingDetailStepBackClicked() {
      this.onSubmitBtnClicked("ClueTrackingDetailStepBack");
    },
    onClueTrackingChangeChannel() {
      this.$refs.form3.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked("UpdateChannel");
      });
    },
    onUpdateCommentClicked(trackingDetailId, oldComment) {
      console.log("onUpdateCommentClicked", trackingDetailId, oldComment);
      this.$refs["modal-update-comment"].$refs["modal-update-comment"].show();
      this.$refs["modal-update-comment"].setModalData(
        trackingDetailId,
        oldComment
      );
    },
    onSubmitBtnClicked(mode) {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let userActive = null;

          let depId = null;
          if (mode === "ClueTrackingSendToDep") {
            depId = _this.internalDep.value;
            userActive = _this.officer.value;
          }

          let provinceCode = null;
          if (mode === "ClueTrackingSendToProvince") {
            provinceCode = _this.province.value;
            userActive = _this.officer.value;
          }

          let channelId = null;
          if (mode === "UpdateChannel") {
            channelId = _this.channel.value;
          }

          const params = {
            mode,
            clueId: _this.$route.query.id,
            comment: _this.comment,
            departmentId: depId,
            provinceCode: provinceCode,
            userActive,
            channelId,
          };
          clueManageStore
            .updateItem(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                _this.$router.go(_this.$router.currentRoute);
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onDelete() {
      this.$refs.form4.validate().then((success) => {
        if (!success) {
          return;
        }

        const _this = this;

        this.$swal({
          title: "ยืนยันการลบข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (_this.deletePin !== "ลบข้อมูล") {
            _this.$bvToast.toast("กรุณากรอกรหัสยืนยันให้ถูกต้อง", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });

            return;
          }
          if (result.value) {
            const params = {
              clueId: _this.$route.query.id,
            };
            clueManageStore
              .deleteItem(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  //_this.$router.push("ComplaintManage");
                  const routeData = this.$router.resolve({
                    name: "ClueAdmin",
                  });
                  window.open(routeData.href, "_self");
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    getInternalDeps() {
      const _this = this;

      storeMaster
        .getDepartment(2)
        .then(function(response) {
          // handle success
          // console.log("response", response);
          _this.internalDeps = response.data.data;
          _this.internalDep = _this.internalDeps[0];

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getProvinces() {
      const _this = this;

      storeMaster
        .getProvince()
        .then((response) => {
          _this.provinces = response.data.data;
          _this.province = _this.provinces[0];
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getOfficer() {
      const _this = this;
      storeMaster
        .getOfficerInfoAll()
        .then(function(response) {
          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.user_id;
            setData.text = o.title_name + " " + o.fname + " " + o.lname;

            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.officers = officerUnique;
          _this.officer = _this.officers[0];

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getChannels() {
      const _this = this;
      storeMaster
        .getMasterByType(1)
        .then((response) => {
          const masters = response.data.data.map(function(obj) {
            return { value: obj.masterId, text: obj.description };
          });
          console.log("masters", masters);
          _this.channels = masters;
          _this.channel = _this.channels[0];
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss"></style>
